import {
  PatientAccountAdditionalDataRequest,
  PatientAccountLoginMfaRequest,
  PatientAccountLoginRequest,
  PublicPatientCreateAccountRequest,
  PublicPatientResetPasswordRequest,
  PublicPatientResetPasswordStartRequest,
  StartPatientAccountRequest,
} from "@shared/dtos/requests/patientAccountRequests.dto"
import { DefaultResponse } from "@shared/dtos/responses/commonResponses.dto"
import {
  LinkPatientAccountFieldsResponse,
  PatientAccountAdditionalDataResponse,
  PatientAccountCreationResponse,
  PatientAccountLinkStatusResponse,
  PatientAccountMfaRequiredResponse,
  PatientAccountPasswordResetMfaRequiredResponse,
  PatientAccountPasswordResetResponse,
  PatientAccountTokenResponse,
} from "@shared/dtos/responses/patientAccountResponses.dto"

import { axiosPublic } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const login = (
  req: PatientAccountLoginRequest
): Promise<
  | PatientAccountMfaRequiredResponse
  | PatientAccountAdditionalDataResponse
  | PatientAccountLinkStatusResponse
  | PatientAccountTokenResponse
> => {
  return axiosPublic({
    url: "/public/patientaccount/login",
    method: "post",
    data: req,
  }).then((resp) => {
    return resp.data
  })
}

export const mfa = (
  req: PatientAccountLoginMfaRequest
): Promise<PatientAccountAdditionalDataResponse | PatientAccountTokenResponse> => {
  return axiosPublic({
    url: "/public/patientaccount/mfa",
    method: "post",
    data: req,
  }).then((resp) => {
    return resp.data
  })
}

export const additionalData = (
  req: PatientAccountAdditionalDataRequest
): Promise<PatientAccountAdditionalDataResponse | PatientAccountTokenResponse> => {
  return axiosPublic({
    url: "/public/patientaccount/additionaldata",
    method: "post",
    data: req,
  }).then((resp) => {
    return resp.data
  })
}

export const createAccountStart = (req: StartPatientAccountRequest): Promise<DefaultResponse> => {
  return axiosPublic({
    url: "/public/patientaccount/create/start",
    method: "post",
    data: req,
  }).then((resp) => {
    return resp.data
  })
}

export const createAccountProcess = (encryptedData: string): Promise<LinkPatientAccountFieldsResponse> => {
  return axiosPublic({
    url: `/public/patientaccount/create/${encryptedData}`,
    method: "get",
  }).then((resp) => {
    return resp.data
  })
}

export const createAccount = (req: PublicPatientCreateAccountRequest): Promise<PatientAccountCreationResponse> => {
  return axiosPublic({
    url: `/public/patientaccount/create`,
    method: "post",
    data: req,
  }).then((resp) => {
    return resp.data
  })
}

export const resetPasswordStart = (req: PublicPatientResetPasswordStartRequest): Promise<DefaultResponse> => {
  return axiosPublic({
    url: `/public/patientaccount/passwordreset/start`,
    method: "post",
    data: req,
  }).then((resp) => {
    return resp.data
  })
}

export const resetPasswordProcess = (
  encryptedData: string
): Promise<PatientAccountPasswordResetMfaRequiredResponse> => {
  return axiosPublic({
    url: `/public/patientaccount/passwordreset/${encryptedData}`,
    method: "get",
  }).then((resp) => {
    return resp.data
  })
}

export const callWithResetToken = (encryptedData: string): Promise<boolean> => {
  return axiosPublic({
    url: `/public/patientaccount/passwordreset/call/${encryptedData}`,
    method: "get",
  }).then((resp) => {
    return resp.data
  })
}

export const resetPassword = (req: PublicPatientResetPasswordRequest): Promise<PatientAccountPasswordResetResponse> => {
  return axiosPublic({
    url: `/public/patientaccount/passwordreset`,
    method: "post",
    data: req,
  }).then((resp) => {
    return resp.data
  })
}
